'use es6';

export var UNINITIALIZED = 'UNINITIALIZED';
export var STARTED = 'STARTED';
export var SUCCEEDED = 'SUCCEEDED';
export var FAILED = 'FAILED';